import React, { Component } from 'react';
import { getAssetUrl } from '../../helper/assets';

class GoogleMap extends Component {
    render() {
        return (
            <div className="google-map-area" style={{ height: 'auto', overflow: 'hidden', position: 'relative' }}>
                <div 
                    className="map-overlay-shade" 
                    style={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        backgroundColor: 'rgba(0, 0, 0, 0.25)',
                        pointerEvents: 'none',
                        zIndex: 1
                    }} 
                />
                <img 
                    src={getAssetUrl("globalAbroad/global_abroad_map.png")} 
                    alt="Global Abroad Office Location Map" 
                    style={{ 
                        width: '100%', 
                        height: 'auto', 
                        display: 'block',
                        opacity: '0.85',
                        filter: 'brightness(0.9)'
                    }}
                />
            </div>
        )
    }
}

export default GoogleMap;